<template>
  <div class="container">
    <div class="row">
      <div class="col">
          <div class="pt-3 pb-3">
            <router-view></router-view>
          </div>
      </div>
    </div>    
    <GlobalFooter></GlobalFooter>
  </div>
</template>
<script>
import GlobalFooter from '../components/GlobalFooter.vue'
export default {
  components: {
    GlobalFooter
  }
}
</script>
<style scoped>

</style>
